import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RxInputModule } from '@nrwl/rx-input';
import { RxNewGroupCompositeComponent } from './rx-new-group-composite.component';

@NgModule({
  imports: [CommonModule, RxInputModule, RxNewGroupCompositeComponent],
  exports: [RxNewGroupCompositeComponent],
})
export class RxNewGroupCompositeModule {}
